var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM365Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6578 13.7188L89.6467 14.3327C88.0352 15.3077 86.514 16.4001 85.0966 17.5918L88.0216 15.5334H112.849L117.363 49.7134L94.7926 72.2833L72.2227 87.9695V106.057C72.2227 118.692 78.8266 130.406 89.6331 136.951L113.395 151.332L63.1947 180.619H53.5121L35.4652 169.695C24.6587 163.155 18.0547 151.436 18.0547 138.802V77.9755C18.0547 65.3363 24.6632 53.618 35.4787 47.0772L89.6467 14.3101C89.9807 14.107 90.3193 13.9083 90.6578 13.7188Z",
    fill: "url(#paint0_radial_1944_2224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.449 85.8281V106.051C144.449 118.686 137.845 130.399 127.038 136.945L72.8701 169.734C61.7883 176.442 48.0025 176.686 36.7266 170.461L89.6396 202.488C101.137 209.448 115.545 209.448 127.038 202.488L181.206 169.698C192.013 163.157 198.617 151.439 198.617 138.804V124.197L194.103 117.426L144.449 85.8281Z",
    fill: "url(#paint1_radial_1944_2224)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.191 47.0733L127.023 14.3062C115.887 7.57134 102.024 7.36369 90.7165 13.6788L89.6467 14.3333C78.8312 20.8741 72.2227 32.5969 72.2227 45.2316V88.0424L89.6467 77.5022C101.139 70.5506 115.534 70.5506 127.027 77.5022L181.195 110.269C191.672 116.607 198.199 127.802 198.597 139.985C198.61 139.592 198.615 139.2 198.615 138.802V77.9716C198.615 65.337 192.006 53.6141 181.191 47.0733Z",
    fill: "url(#paint2_radial_1944_2224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1944_2224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.707 47.994) rotate(110.528) scale(141.425 246.675)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1944_2224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.915 164.008) rotate(-8.36713) scale(140.161 92.5858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#591C96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1944_2224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.269 119.9) rotate(-165.772) scale(133.877 225.369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM365Logo);
export default __webpack_public_path__ + "static/media/m365-logo.8f03c37857ed5cd57a055e1fa63e7881.svg";
export { ForwardRef as ReactComponent };